<template>
  <data-list class="select_checkbox_column_width_0" :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
</template>
<script>
import DataList from '../../components/DataList.vue'
import { mapState, mapGetters } from 'vuex'
export default {
  data () {
    return {
      listPayloadObj: {
        isHeader: true,
        isHideAdd: false,
        selection: [],
        showSelect: true,
        addNewRoute: () => this.$router.push('/users/actions'),
        list: [],
        loading: true,
        page: 1,
        editProp: 'firstname',
        editURL: (item) => `users/actions/${item.id}`
      },
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.USER_INDEX) ? this.$store.state.USER_INDEX : { sortBy: ['firstname'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'users'
    }
  },
  components: {
    DataList
  },
  computed: {
    ...mapState(['USER_INDEX']),
    ...mapGetters(['getuserDetails']),
    headers () {
      return [{
        text: this.$t('message.user.firstName'),
        value: 'firstname',
        width: '15%'
      }, {
        text: this.$t('message.user.lastName'),
        value: 'lastname',
        width: '10%'
      }, {
        text: this.$t('message.login.userName'),
        value: 'username',
        width: '15%'
      }, {
        text: this.$t('message.user.email'),
        value: 'email',
        width: '20%'
      }, {
        text: this.$t('message.user.mobile'),
        value: 'phone',
        width: '15%'
      }, /* {
        text: this.$t('message.user.pin'),
        value: 'pin',
        width: '10%'
      },  */{
        text: this.$t('message.user.role'),
        value: 'userrole_name',
        width: '10%'
      }, {
        text: this.$t('message.common.isActive'),
        value: 'isactive',
        isBoolean: true,
        sortable: false,
        width: '5%'
      }]
    }
  },
  watch: {
    pagination (val) {
      let model = { type: 'USER_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    }
  },
  mounted () {
    // No edit action for Technician, office!
    if (this.getuserDetails.role === 2 || this.getuserDetails.role === 3) {
      this.listPayloadObj.editProp = ''
      this.listPayloadObj.isHideAdd = true
      this.listPayloadObj.showSelect = false
    }
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        let payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      let fields = this.$formatter.cloneVariable(this.headers)
      fields.splice(5, 1)
      let queryFields = fields
      let { page, search, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let result = queryFields.find(x => x.value === sortBy[0])
      let pageVal = page || 1
      let query = {
        'order_by': {
          'field': result ? result.value : '',
          'asc_or_desc': sortDesc[0] ? 'desc' : 'asc'
        },
        'skip': ((pageVal - 1) * itemsPerPage),
        'limit': itemsPerPage,
        'include_count': true,
        'filter': `${queryFields.map(x => x.value).join(` contains '${search || ''}' OR `)} contains '${search || ''}'`
      }
      this.$_executeApi('post', `${this.MODULE}/query`, query)
        .then((response) => {
          let { values, count } = response.data
          this.listPayloadObj.loading = false
          values.forEach(element => {
            if (element.role) {
              const result = this.listOfUserRoles.find(x => x.id === element.role)
              if (result) element.userrole_name = result.name
            }
          })
          this.listPayloadObj.list = values
          this.total = count
          if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
            this.pagination.page = 1
            this.listPayloadObj.page = 1
          }
        })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
